<app-menu class="menuApp"></app-menu>
<div class="main">
  <div style="width: 90%; margin: auto;">

      <div class="row">
        <div class="col-2" style="margin-top: 2vh">
          <button (click)="newRegla(0)" class="buttonNewRegla textS">{{this.localiser.get("rules.new")}}</button>
        </div>
      </div>

      <div class="row reglaSection">
        <div class="reglaHeader">
          <h1 class="centerVert textXXM">{{this.localiser.get("rules.title")}}</h1>
        </div>
        <div class="reglaTable">
          <table style="width:100%">
            <tr class="bottomBorder fixHeaderTable">
              <th class="textS">{{this.localiser.get("rules.name")}}</th>
              <th></th>
              <th></th>
            </tr>
            <tr *ngFor="let regla of reglas">
              <td style="width: 94%" class="textS">{{regla.nombre}}</td>
              <td style="width: 3%">
                <span (click)="deleteRegla(regla)" class="textM material-icons-outlined deleteIcon">delete</span>
              </td>
              <td style="width: 3%">
                <span (click)="newRegla(regla.idRegla)" class="textM material-icons-outlined deleteIcon">edit</span>
              </td>
            </tr>
          </table>
          <div style="margin: 1% 0">
            <h3 *ngIf="reglas != undefined && reglas.length == 0" class="textXM" style="text-align: center">{{this.localiser.get("rules.noRules")}}</h3>
            <mat-progress-spinner *ngIf="reglas == undefined" class="marginAuto" color="primary" mode="indeterminate" diameter="50"></mat-progress-spinner>
          </div>
        </div>
      </div>

  </div>
</div>
